<template>
  <div class="container">
    <div class="columns">
      <div class="column is-8" v-if="!mod.isElastic">
        <div class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has(`fodmat`) }"
              :label="$translate('fodmat') | capitalize"
              :message="errors.first(`fodmat`)"
            >
              <b-select
                v-validate="'required'"
                name="fodmat"
                :disabled="disabledbool"
                :value="fodAntMat"
                :placeholder="$translate('placeholder_select')"
                @input="
                  setFodAnt($event)
                  setFodPos($event)
                "
              >
                <option
                  v-for="optio in mod.fodmat"
                  :key="optio.material + optio.variant.id"
                  :value="optio.material"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>

            <b-field
              v-if="fodAntMat != null"
              :type="{ 'is-danger': errors.has(`fodmat-ant-variant`) }"
              :label="$translate('fodantvar') | capitalize"
              :message="errors.first(`fodmat-ant-variant`)"
            >
              <b-select
                v-validate="'required'"
                :disabled="disabledbool"
                :value="fodAntVar.id"
                :name="`fodmat-ant-variant`"
              >
                <option :value="fodAntVar.id">{{ $translateMaterialVariant(fodAntVar) }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="imageAnt ? imageAnt : 'https://place-hold.it/150x150'"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>
      </div>
      <div v-else class="column is-8">
        <div class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has(`fodmat-ant`) }"
              :label="$translate('fodmat_ant') | capitalize"
              :message="errors.first(`fodmat-ant`)"
            >
              <b-select
                v-validate="'required'"
                :disabled="disabledbool"
                name="fodmat-ant"
                :value="fodAntMat"
                :placeholder="$translate('placeholder_select')"
                @input="setFodAnt($event)"
              >
                <option
                  v-for="optio in mod.fodmat"
                  :key="optio.material + optio.variant.id"
                  :value="optio.material"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>

            <b-field
              v-if="fodAntMat != null"
              :disabled="disabledbool"
              :type="{ 'is-danger': errors.has(`fodmat-ant-variant`) }"
              :label="$translate('fodantvar') | capitalize"
              :message="errors.first(`fodmat-ant-variant`)"
            >
              <b-select v-validate="'required'" :value="fodAntVar.id" :name="`fodmat-ant-variant`">
                <option :value="fodAntVar.id">{{ $translateMaterialVariant(fodAntVar) }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="imageAnt ? imageAnt : 'https://place-hold.it/150x150'"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has(`fodmat-pos`) }"
              :label="$translate('fodmat_pos') | capitalize"
              :message="errors.first(`fodmat-pos`)"
            >
              <b-select
                v-validate="'required'"
                :disabled="disabledbool"
                name="fodmat-pos"
                :value="fodPosMat"
                :placeholder="$translate('placeholder_select')"
                @input="setFodPos($event)"
              >
                <option
                  v-for="optio in mod.fodmat"
                  :key="optio.material + optio.variant.id"
                  :value="optio.material"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>

            <b-field
              v-if="fodPosMat != null"
              :type="{ 'is-danger': errors.has(`fodmat-pos-variant`) }"
              :label="$translate('fodposvar') | capitalize"
              :message="errors.first(`fodmat-pos-variant`)"
            >
              <b-select
                v-validate="'required'"
                :disabled="disabledbool"
                :value="fodPosVar.id"
                name="fodmat-pos-variant"
              >
                <option :value="fodPosVar.id">{{ $translateMaterialVariant(fodPosVar) }}</option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <img
              :src="imagePos ? imagePos : 'https://place-hold.it/150x150'"
              style="max-width: 150px; max-height: 150px;"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <b-field :label="$translate('addingcharfod') | capitalize">
          <b-select
            v-model="mod.addingcharfod"
            multiple
            native-size="5"
            :disabled="orderbool"
            name="addingcharfod"
            :placeholder="$translate('placeholder_select')"
          >
            <option v-for="option in optionsaddingcharfod" :key="option" :value="option">
              {{ option }}
            </option>
          </b-select>
        </b-field>
        <p class="content">* {{ $translate('multiple_select_info') | capitalize }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fodera',
  props: ['orderbool', 'mod', 'availablefode', 'disabledbool'],
  data() {
    return {
      fodAntMat: null,
      fodAntVar: null,
      imageAnt: null,
      fodPosMat: null,
      fodPosVar: null,
      imagePos: null,
      optionsaddingcharfod: [],
    }
  },
  inject: ['$validator'],
  watch: {
    mod: {
      handler() {
        if (this.mod.fodantmat && this.mod.fodposmat) {
          this.setFodAnt(this.mod.fodantmat)
          this.setFodPos(this.mod.fodposmat)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (!Array.isArray(this.mod.fodmat)) {
      this.$set(this.mod, 'fodmat', [{ material: null, variant: {}, image: null }])
    }
  },
  methods: {
    setFodAnt(value) {
      this.fodAntMat = value
      const material = this.mod.fodmat.find(f => f.material === value)
      this.fodAntVar = material.variant
      this.imageAnt = material.variant.image
      this.updateAddingCharFod(value)
      this.mod.fodantmat = this.fodAntMat
      this.mod.fodantvar = this.fodAntVar.id
      this.$emit('update:mod', this.mod)
    },
    setFodPos(value) {
      this.fodPosMat = value
      const material = this.mod.fodmat.find(f => f.material === value)
      this.fodPosVar = material.variant
      this.imagePos = material.variant.image
      this.updateAddingCharFod(value)
      this.mod.fodposmat = this.fodPosMat
      this.mod.fodposvar = this.fodPosVar.id
      this.$emit('update:mod', this.mod)
    },
    updateAddingCharFod(material) {
      this.optionsaddingcharfod = []
      const fodera = this.availablefode.find(optio => optio.id === material)
      if (fodera) {
        fodera.optional_tag.forEach(tag => {
          if (!this.optionsaddingcharfod.includes(tag.key)) {
            this.optionsaddingcharfod.push(tag.key)
          }
        })
      }
    },
  },
}
</script>
